/**
 * Fetch the HTML for a SVG icon
 * @param absolutePath Path like `"/assets/icons/banana.svg"`
 * @returns The SVG HTML
 */
export const fetchIcon = async (absolutePath: string) => {
  const body = await fetch(absolutePath).then((r) => r.text());
  return body;
};

export const atomIcon = () => {
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll('[is="atom-icon"]:not(.loaded)')
  );

  components.forEach(async (component) => {
    if (component.shadowRoot) {
      component.classList.add('loaded');
      return;
    }

    component.classList.add('loaded');

    const fileName = component.dataset.icon;
    if (!fileName) {
      component.remove();
      console.error('Missing [data-icon] on', component);
      return;
    }

    /** Defines from where we load the icon. Can be `"assets"` (which refers to frontend/src/static/assets) or `"uploads"` (which refers to web/uploads). */
    const source = component.getAttribute('data-source');
    const fullPath = `/${source}/icons/${fileName}`;

    const style = document.createElement('style');
    if (component.classList.contains('cover')) {
      style.textContent = `
      svg {
        position: absolute;
        width: 100%;
        height: ${component.classList.contains('stretch') ? '100%' : 'auto'};
        left: 0;
        top: 0;
        object-fit: cover;
      }
      `;
    } else {
      style.textContent = `
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
      svg {
        width: 100%;
        height: 100%;
      }
      `;
    }

    const svgContainer = document.createElement('span');

    const svg = await fetchIcon(fullPath);
    svgContainer.innerHTML = svg;

    const svgElement = svgContainer.querySelector('svg');

    if (!svgElement) {
      component.remove();
      console.error(`Unable to load icon "${fileName}" from ${fullPath}`);
      return;
    }

    if (component.classList.contains('stretch')) {
      svgElement.setAttribute('preserveAspectRatio', 'none');
    }

    if (component.hasAttribute('aria-label')) {
      svgElement.setAttribute(
        'aria-label',
        component.getAttribute('aria-label')
      );
      component.removeAttribute('aria-label');
    }
    svgElement.setAttribute('role', 'img');

    const shadow =
      component.shadowRoot ??
      component.attachShadow({
        mode: 'open'
      });
    shadow.append(svgContainer);
    shadow.appendChild(style);
  });
};
